// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-item__row {
    cursor: pointer;
}

.chat-item__row tr {
    border-bottom: 0px;
}

.chat-item__row td {
    padding: 0px;
    margin-right: 1rem;
}

.chat-item__chat-id {
    font-style: italic;
    font-size: small;
    color: #ccc;
}

.chat-item__chat-type {
    font-size: small;
    float: left;
    padding-right: 2rem !important;
    padding-left: 2rem !important;
    border-radius: 2px;
}

.chat-item__chat-type.chat-type-private {
    background-color: rgba(185, 196, 196, 0.4);
}

.chat-item__chat-type.chat-type-comment {
    background-color: rgba(156, 247, 171, 0.4);
}

.chat-item__chat-type.chat-type-group {
    background-color: rgba(170, 156, 247, 0.4);
}

.chat-item__chat-type.chat-type-mailing {
    background-color: rgba(247, 218, 156, 0.4);
}

.chat-item__chat-info {
    text-align: right;
    padding-right: 2rem !important;
}

.chat-item__contact-info_row {
    padding: 0px;
}

.chat-item__contact-message-column {
    min-width: 30rem;
    width: 25px;
    margin-right: 1rem;
}

.chat-item__contact-info_avatar {
    width: 5rem;
}

.chat-item__contact-info_avatar svg {
    width: 100% !important;
    height: 100% !important;
}

.chat-item__operator-info_avatar {
    width: 5rem;
    padding-right: 2rem !important;
}

.chat-item__contact-info_chat-info {
    text-align: left;
    width: 70%;
}

.chat-item__contact-info_name-editor {
    display: flex;
    flex-direction: row;
    font-size: 1.8rem !important;
    height: 1.8rem !important;
}

.chat-item__contact-info_name-editor-input,
.chat-item__contact-info_name-editor-input:hover,
.chat-item__contact-info_name-editor-input:focus {
    border: none !important;
    height: 2.1rem !important;
    width: auto !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
    padding-left: .5rem !important;
    margin-right: .5rem !important;
    font-size: 1.8rem !important;
}

.chat-item__contact-info_change-name-btn,
.chat-item__contact-info_change-name-btn:focus {
    height: 2.1rem;
    width: auto;
    line-height: 0;
    padding: 0.4rem;
    margin: 0;
    border: none;
    box-shadow: none;
    color: '#fff';
}

.chat-item__contact-info_change-name-btn:hover {
    background: #AAAAAA;
    color: black;
}

.chat-item__contact-info_name {
    text-align: left;
    font-weight: bold;
    font-size: 1.8rem;
    font-weight: 500;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    max-width: 70%;
}

.chat-item__contact-message-column{
    max-width: 23rem;
}

.chat-item__contact-info_message {
    margin-top: .3rem;
    font-weight: normal;
    text-align: left;
    overflow: hidden;
}

.line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.chat-item__contact-avatar {
    width: 5rem !important;
    height: 5rem !important;
    margin: 0 1rem;
    border-radius: 50%;
    vertical-align: inherit;
    box-shadow: 0px 0px 2px 1px #ccc;
}

.chat-item__contact-avatar svg {
    width: 100% !important;
    height: 100% !important;
}

.chat-item__operator-avatar {
    width: 5rem !important;
    height: 5rem !important;
    border-radius: 50%;
    box-shadow: 0px 0px 2px 1px #ccc;
    margin-left: 1rem;
}

.chat-item__operator-avatar svg {
    width: 100% !important;
    height: 100% !important;
}

.chat-item__contact-info-cell {
    text-align: center;
    padding: 1rem 0 1rem 1rem !important;
}

.chat-item__messenger-status-cell {
    min-width: 10rem;
}

.chat-item__messenger-info-cell {
    max-width: 15rem;
    padding: 1rem !important;
    padding-right: none !important;
}

.chat-item__messenger {
    display: flex;
    align-items: center;
    justify-content: center;
}

.chat-item__messenger-img {
    width: 1.8rem;
    height: 1.8rem;
    display: inline-block;
}

.chat-item__channel-name {
    display: block;
    max-width: 15rem;
    margin-left: 8px;
}

    .chat-item__channel-name > div {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

.chat-item__is-closed-text {
    font-size: 1.8rem;
    font-weight: 500;
}

.chat-item__operator-info {
    white-space: pre-line;
    display: block;
    font-size: 1.6rem;
    font-weight: 500;
    min-width: 5rem;
    overflow: hidden;
    float: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}

.chat-item__operator-info-cell {
    width: 20rem;
    text-align: center;
}

.chat-item__row:hover {
    transition: 0.1s;
    box-shadow: 0px 0px 8px 1px #26a69a !important;
}

.chat-item__row-selected {
    background: linear-gradient(to right, #26a69a 1rem, transparent 0px);
}

.chat-item__chat-paused {
    float: right;
    font-size: small;
    font-weight: bold;
    margin-right: 2rem;
    margin-top: -.3rem;
    padding:  0rem 1rem;
    border: 2px solid orange;
}

.chat-item__chat-created-time {
    font-style: italic;
    font-size: small;
    float: right;
}

.chat-item__contact-info_sender {
    font-style: italic;
    text-decoration: underline;
    margin-left: 5px;
    margin-right: 5px;
}

.chat-item-without-message-from-operator {
    font-weight: bold;
}

.chat-item__not-answered-messages-count {
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.1rem;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
    text-align: center;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    margin-left: 1rem;
    margin-right: -1rem;
}

.not-answered-messages-count-closed-chat {
    box-shadow: 0px 0px 1px 1px black;
    color: black;
}

.not-answered-messages-count-chat-with-not-answered-messages {
    background-color: #d22e37;
}

.not-answered-messages-count-withme-chat {
    background-color: #d6ac17;
}

.not-answered-messages-count-chat-without-not-answered-messages {
    background-color: #26a69a;
}

.chat-item-with-message-from-operator-message-time {
    font-style: italic;
    font-size: small;
}

.chat-item__messenger-img-open-chat {
    float: right;
    width: 1.8rem;
    height: 1.8rem;
    margin: 0 1rem;
}

.chat-item__messenger-logo-cell{
    width: 1.8rem;
    height: 1.8rem;
    padding: 0 !important; 
}

.chat-item__operator-info_avatar-chat-visible {
    width: 5rem;
    padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/chats/chats-main/chats-list/chats-item/ChatsItem.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;;;IAGI,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;IAC9B,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;IACd,eAAe;IACf,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;IAEI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;IAC3B;;AAEJ;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,wHAAwH;IACxH,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB","sourcesContent":[".chat-item__row {\r\n    cursor: pointer;\r\n}\r\n\r\n.chat-item__row tr {\r\n    border-bottom: 0px;\r\n}\r\n\r\n.chat-item__row td {\r\n    padding: 0px;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.chat-item__chat-id {\r\n    font-style: italic;\r\n    font-size: small;\r\n    color: #ccc;\r\n}\r\n\r\n.chat-item__chat-type {\r\n    font-size: small;\r\n    float: left;\r\n    padding-right: 2rem !important;\r\n    padding-left: 2rem !important;\r\n    border-radius: 2px;\r\n}\r\n\r\n.chat-item__chat-type.chat-type-private {\r\n    background-color: rgba(185, 196, 196, 0.4);\r\n}\r\n\r\n.chat-item__chat-type.chat-type-comment {\r\n    background-color: rgba(156, 247, 171, 0.4);\r\n}\r\n\r\n.chat-item__chat-type.chat-type-group {\r\n    background-color: rgba(170, 156, 247, 0.4);\r\n}\r\n\r\n.chat-item__chat-type.chat-type-mailing {\r\n    background-color: rgba(247, 218, 156, 0.4);\r\n}\r\n\r\n.chat-item__chat-info {\r\n    text-align: right;\r\n    padding-right: 2rem !important;\r\n}\r\n\r\n.chat-item__contact-info_row {\r\n    padding: 0px;\r\n}\r\n\r\n.chat-item__contact-message-column {\r\n    min-width: 30rem;\r\n    width: 25px;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.chat-item__contact-info_avatar {\r\n    width: 5rem;\r\n}\r\n\r\n.chat-item__contact-info_avatar svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.chat-item__operator-info_avatar {\r\n    width: 5rem;\r\n    padding-right: 2rem !important;\r\n}\r\n\r\n.chat-item__contact-info_chat-info {\r\n    text-align: left;\r\n    width: 70%;\r\n}\r\n\r\n.chat-item__contact-info_name-editor {\r\n    display: flex;\r\n    flex-direction: row;\r\n    font-size: 1.8rem !important;\r\n    height: 1.8rem !important;\r\n}\r\n\r\n.chat-item__contact-info_name-editor-input,\r\n.chat-item__contact-info_name-editor-input:hover,\r\n.chat-item__contact-info_name-editor-input:focus {\r\n    border: none !important;\r\n    height: 2.1rem !important;\r\n    width: auto !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    line-height: 0 !important;\r\n    padding-left: .5rem !important;\r\n    margin-right: .5rem !important;\r\n    font-size: 1.8rem !important;\r\n}\r\n\r\n.chat-item__contact-info_change-name-btn,\r\n.chat-item__contact-info_change-name-btn:focus {\r\n    height: 2.1rem;\r\n    width: auto;\r\n    line-height: 0;\r\n    padding: 0.4rem;\r\n    margin: 0;\r\n    border: none;\r\n    box-shadow: none;\r\n    color: '#fff';\r\n}\r\n\r\n.chat-item__contact-info_change-name-btn:hover {\r\n    background: #AAAAAA;\r\n    color: black;\r\n}\r\n\r\n.chat-item__contact-info_name {\r\n    text-align: left;\r\n    font-weight: bold;\r\n    font-size: 1.8rem;\r\n    font-weight: 500;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 1;\r\n    overflow: hidden;\r\n    max-width: 70%;\r\n}\r\n\r\n.chat-item__contact-message-column{\r\n    max-width: 23rem;\r\n}\r\n\r\n.chat-item__contact-info_message {\r\n    margin-top: .3rem;\r\n    font-weight: normal;\r\n    text-align: left;\r\n    overflow: hidden;\r\n}\r\n\r\n.line-clamp {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n}\r\n\r\n.chat-item__contact-avatar {\r\n    width: 5rem !important;\r\n    height: 5rem !important;\r\n    margin: 0 1rem;\r\n    border-radius: 50%;\r\n    vertical-align: inherit;\r\n    box-shadow: 0px 0px 2px 1px #ccc;\r\n}\r\n\r\n.chat-item__contact-avatar svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.chat-item__operator-avatar {\r\n    width: 5rem !important;\r\n    height: 5rem !important;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 0px 2px 1px #ccc;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.chat-item__operator-avatar svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.chat-item__contact-info-cell {\r\n    text-align: center;\r\n    padding: 1rem 0 1rem 1rem !important;\r\n}\r\n\r\n.chat-item__messenger-status-cell {\r\n    min-width: 10rem;\r\n}\r\n\r\n.chat-item__messenger-info-cell {\r\n    max-width: 15rem;\r\n    padding: 1rem !important;\r\n    padding-right: none !important;\r\n}\r\n\r\n.chat-item__messenger {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.chat-item__messenger-img {\r\n    width: 1.8rem;\r\n    height: 1.8rem;\r\n    display: inline-block;\r\n}\r\n\r\n.chat-item__channel-name {\r\n    display: block;\r\n    max-width: 15rem;\r\n    margin-left: 8px;\r\n}\r\n\r\n    .chat-item__channel-name > div {\r\n        display: block;\r\n        width: 100%;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n.chat-item__is-closed-text {\r\n    font-size: 1.8rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.chat-item__operator-info {\r\n    white-space: pre-line;\r\n    display: block;\r\n    font-size: 1.6rem;\r\n    font-weight: 500;\r\n    min-width: 5rem;\r\n    overflow: hidden;\r\n    float: right;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 200px;\r\n}\r\n\r\n.chat-item__operator-info-cell {\r\n    width: 20rem;\r\n    text-align: center;\r\n}\r\n\r\n.chat-item__row:hover {\r\n    transition: 0.1s;\r\n    box-shadow: 0px 0px 8px 1px #26a69a !important;\r\n}\r\n\r\n.chat-item__row-selected {\r\n    background: linear-gradient(to right, #26a69a 1rem, transparent 0px);\r\n}\r\n\r\n.chat-item__chat-paused {\r\n    float: right;\r\n    font-size: small;\r\n    font-weight: bold;\r\n    margin-right: 2rem;\r\n    margin-top: -.3rem;\r\n    padding:  0rem 1rem;\r\n    border: 2px solid orange;\r\n}\r\n\r\n.chat-item__chat-created-time {\r\n    font-style: italic;\r\n    font-size: small;\r\n    float: right;\r\n}\r\n\r\n.chat-item__contact-info_sender {\r\n    font-style: italic;\r\n    text-decoration: underline;\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.chat-item-without-message-from-operator {\r\n    font-weight: bold;\r\n}\r\n\r\n.chat-item__not-answered-messages-count {\r\n    float: right;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #fff;\r\n    font-size: 1.1rem;\r\n    font-family: -apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen-Sans,Ubuntu,Cantarell,\"Helvetica Neue\",sans-serif;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    margin-left: 1rem;\r\n    margin-right: -1rem;\r\n}\r\n\r\n.not-answered-messages-count-closed-chat {\r\n    box-shadow: 0px 0px 1px 1px black;\r\n    color: black;\r\n}\r\n\r\n.not-answered-messages-count-chat-with-not-answered-messages {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.not-answered-messages-count-withme-chat {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.not-answered-messages-count-chat-without-not-answered-messages {\r\n    background-color: #26a69a;\r\n}\r\n\r\n.chat-item-with-message-from-operator-message-time {\r\n    font-style: italic;\r\n    font-size: small;\r\n}\r\n\r\n.chat-item__messenger-img-open-chat {\r\n    float: right;\r\n    width: 1.8rem;\r\n    height: 1.8rem;\r\n    margin: 0 1rem;\r\n}\r\n\r\n.chat-item__messenger-logo-cell{\r\n    width: 1.8rem;\r\n    height: 1.8rem;\r\n    padding: 0 !important; \r\n}\r\n\r\n.chat-item__operator-info_avatar-chat-visible {\r\n    width: 5rem;\r\n    padding: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
